import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=56909ab4&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"
import style0 from "./report-card.css?vue&type=style&index=0&lang=css&"
import style1 from "./add.css?vue&type=style&index=1&id=56909ab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56909ab4",
  null
  
)

export default component.exports